 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowAccidentData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="Accident"><i className="icofont icofont-car f20"></i>&nbsp; </a>
        
    );
};

export default ConsignmentActions;
